<template>
  <div
    :id="commentThreadId"
    class="pega-comment thread"
    :class="[{ 'boss-c': commentThread.isCompanyStaff }, { 'boss-s': !commentThread.isCompanyStaff }, { 'fixed' : allFixed }]"
    data-test="comment-thread-top"
    @click.stop
    @select.stop
  >
    <div
      v-if="isShowDeleteIcon"
      class="boss-icon-cross delete-icon"
      data-test="delete-icon"
      @click="deleteThread"
    />
    <div
      :class="{ 'is-open': isOpen }"
      class="comment-accordion"
      data-test="comment-accordion"
    >
      <div
        class="boss-mini-accordion-head comment-header"
        data-test="comment-header"
        @click="toggle"
      >
        「{{ commentThread.targetText }}」へのコメント
      </div>
      <div class="boss-mini-accordion-body comment-body">
        <hr class="solid">
        <template v-if="isShowAllFixed">
          <!-- BOSS-S用機能：すべて修正済みチェックボックス -->
          <div
            class="comment-piece"
            data-test="all-fixed-for-boss-s"
          >
            <label
              class="boss-checkbox"
              :class="{ 'red': allFixed }"
              data-test="checkbox-label"
            >
              <input
                :checked="allFixed"
                class="boss-input-checkbox"
                type="checkbox"
                data-test="checkbox"
                @click="toggleFixedAll"
              >{{ allFixed | fixedText }}
            </label>
          </div>
          <hr data-test="all-fixed-for-boss-s-hr">
        </template>
        <job-preview-comment
          v-for="comment in comments"
          :key="comment.id"
          :comment="comment"
          v-on="$listeners"
        />
        <textarea
          v-if="isAddingComment"
          ref="addComment"
          v-model="addingComment.comment"
          class="edit-comment"
          :class="{'pending':isPending}"
          data-test="add-comment"
        />
        <div
          v-else
          class="grid-x"
        >
          <div
            class="cell medium-2 pega-cursor-pointer"
            @click="toggle"
          >
            <div
              class="comment-close-button"
              data-test="comment-close-button"
            />
          </div>
          <div class="cell auto">
            <div
              class="add-area"
              data-test="add-area"
            >
              <button
                class="boss-button add-button"
                data-test="add-button"
                @click="add"
              >
                コメントを追加する
              </button>
            </div>
          </div>
          <div class="cell medium-2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JobPreviewComment from '@/components/atoms/JobPreviewComment'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  filters: {
    fixedText (val) {
      return val ? 'すべて修正済み' : 'すべて修正済みにする'
    }
  },
  components: {
    JobPreviewComment
  },
  mixins: [jobPreviewCommon],
  props: {
    commentThread: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    addingComment () {
      return this.commentThread.addingComment
    },
    isAddingComment () {
      return !!this.addingComment // 編集中コメントがあればtrue
    },
    commentThreadId () {
      return this.commentThread.highlight
        ? `comment-${this.commentThread.target}-${this.commentThread.highlight.start}`
        : ''
    },
    isShowDeleteIcon () {
      // 制作担当者 または 企業担当者 かつ BOSS-C側スレッドの場合のみ表示
      // - 企業担当者 かつ BOSS-S側スレッドの場合は、表示しない
      return !this.isCompanyStaffAccess ||
      (this.isCompanyStaffAccess && this.commentThread.isCompanyStaff)
    },
    isShowAllFixed () {
      return !this.isCompanyStaffAccess && this.comments.length
    },
    allFixed () {
      return this.comments.length && this.comments.every(comment => comment.isFixed)
    },
    isOpen () {
      return this.commentThread.isOpen
    },
    isPending () {
      return this.addingComment && this.addingComment.comment.trim().length !== 0
    },
    comments () {
      return this.commentThread.comments
    }
  },
  watch: {
    commentThread: {
      handler () {
        // threadIdとtitleを追加
        this.commentThread.comments.forEach(comment => {
          this.$set(comment, 'threadId', this.commentThread.id)
          this.$set(comment, 'threadTitle', this.commentThread.targetText)
        })
      },
      immediate: true
    },
    addingComment: {
      // コメント追加時に画面とフォーカスをコメントへ飛ばす処理
      async handler (val) {
        // immediateで呼ばれるので、addingCommentが空の時には処理をskipさせる
        // - ハイライトから新規作成された時はimmediateで拾う必要があるので
        if (val) {
          await this.$nextTick()
          // ソート操作の都合上、watchが複数回呼ばれるので、各処理が1度ずつしか動かないよう制御

          // コメントが表示されるように横スクロールする
          if (!this.commentThread.scrolled && this.commentThreadId) {
            this.$set(this.commentThread, 'scrolled', true)
            await this.$scrollTo(`#${this.commentThreadId}`, 500, { x: true, y: false })
            await this.$nextTick()
          }

          // テキストボックスにフォーカスを当てる
          if (!this.commentThread.focused && this.$refs.addComment) {
            this.$set(this.commentThread, 'focused', true)
            this.$refs.addComment.focus()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    deleteThread () {
      // $listeners経由でJobPrePublishedPreviewまでemit
      this.$emit('deleteThread', this.commentThread)
    },
    toggle () {
      // $listeners経由でJobPrePublishedPreviewまでemit
      this.$emit('toggleThread', this.commentThread)
    },
    toggleFixedAll () {
      // $listeners経由でJobPrePublishedPreviewまでemit
      this.$emit('toggleFixed', this.comments, !this.allFixed)
    },
    add () {
      // $listeners経由でJobPrePublishedPreviewまでemit
      this.$emit('addComment', this.commentThread)

      this.$emit('setLine')
    }
  }
}
</script>
